module.exports = __webpack_public_path__ + "img/horizontal_7_7_3016.7e971f72.png";